"use client"

import { Controller, FieldPath, FieldValues, useFormContext } from "react-hook-form"
import { FormControl, FormItem, FormMessage } from "../../ui/shadcn/form"
import { DualImageUpload } from "../components/dual-image-upload"
import { ReferenceImagesUpload } from "../components/reference-images-upload"
import { SingleImageUpload } from "../components/single-image-upload"
import type { ParsedField } from "../types"

interface ImageUploadFieldProps {
	field: ParsedField
}

export function ImageUploadField({ field: parsedField }: ImageUploadFieldProps) {
	const { name, schema } = parsedField
	const { control } = useFormContext()
	const uiType = schema["x-ui-type"] || "single"
	const onWorkHistorySelect = schema["x-ui-on-work-history-select"]

	return (
		<Controller
			name={name as FieldPath<FieldValues>}
			control={control}
			render={({ field }) => (
				<FormItem>
					<FormControl>
						{uiType === "references" ? (
							<ReferenceImagesUpload value={(field.value as string[]) || []} onChange={field.onChange} onWorkHistorySelect={onWorkHistorySelect} />
						) : uiType === "dual" ? (
							<DualImageUpload value={(field.value as string[]) || []} onChange={field.onChange} onWorkHistorySelect={onWorkHistorySelect} />
						) : (
							<SingleImageUpload value={(field.value as string) || ""} onChange={field.onChange} onWorkHistorySelect={onWorkHistorySelect} />
						)}
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
